import './anchor-navigation.scss';
// import { getOffset, smoothScrollTo } from './../../utilities/js/helper';
import { getOffset } from './../../utilities/js/helper';

class AnchorNavigation {
    constructor (element, options) {
        const settings = {
            initAttr: 'data-anchor-navigation',
            anchorAttr: 'anchor',
            itemAttr: 'item',
            eventScroller: null
        };

        this.settings = Object.assign({}, settings, options);
        this.$anchorNavigation = element;
        this.$anchorNavigationItems = this.$anchorNavigation.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.itemAttr + '"]');
        this.eventScroller = window.eventScroller;
        this.anchorTimeout = null;

        if (this.eventScroller !== null) {
            this.initialize();
        }
    }

    initialize () {
        this.checkAnchorPosition();
        this.setEvents();
    }

    setEvents () {
        this.eventScroller.customFunctions.push(() => {
            this.checkAnchorPosition();
        });

        for (let i = 0; i < this.$anchorNavigationItems.length; i++) {
            const $currentItem = this.$anchorNavigationItems[i].querySelector('a[href]');

            $currentItem.addEventListener('click', (e) => {
                const targetId = $currentItem.getAttribute('href').split('#')[1];
                const $target = document.getElementById(targetId);

                if ($target !== null) {
                    const anchorDimensions = getOffset($target);
                    const anchorDimensionsTop = anchorDimensions.top;

                    window.scrollTo({
                        top: anchorDimensionsTop,
                        left: 0,
                        behavior: 'smooth'
                    });

                    if (window.siteheaderAPI) {
                        clearTimeout(this.anchorTimeout);
                        this.anchorTimeout = window.setTimeout(() => {
                            window.siteheaderAPI.toggleHeader(false);
                        }, 500);
                    }

                    this.setActiveAnchorItem(targetId);
                }

                e.preventDefault();
            });
        }
    }

    setActiveAnchorItem (id) {
        const $activeTarget = this.$anchorNavigation.querySelector('a[href="#' + id + '"]');

        if ($activeTarget == null) {
            return false;
        }

        const $activeItem = $activeTarget.parentNode;

        for (let a = 0; a < this.$anchorNavigationItems.length; a++) {
            const $currentItem = this.$anchorNavigationItems[a];

            if ($currentItem === $activeItem) {
                const currentItemOffsetLeft = $currentItem.offsetLeft;
                const firstItemOffsetLeft = this.$anchorNavigationItems[0].offsetLeft;

                const scrollLeft = currentItemOffsetLeft - firstItemOffsetLeft;

                $currentItem.classList.add('anchor-navigation__item--active');
                this.$anchorNavigation.scrollTo({
                    top: 0,
                    left: scrollLeft,
                    behavior: 'smooth'
                });

                history.replaceState(null, null, '#' + id);
            } else {
                $currentItem.classList.remove('anchor-navigation__item--active');
            }
        }
    }

    checkAnchorPosition () {
        const $anchors = document.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.anchorAttr + '"]');

        for (let i = 0; i < $anchors.length; i++) {
            const $currentAnchor = $anchors[i];
            const elementDimensions = $currentAnchor.getBoundingClientRect();
            const elementTop = elementDimensions.top;

            if (elementTop - window.innerHeight / 8 <= 0) {
                this.currentActiveId = $currentAnchor.getAttribute('id');
            }
        }

        if (this.activeAnchorId !== this.currentActiveId) {
            this.activeAnchorId = this.currentActiveId;

            this.setActiveAnchorItem(this.activeAnchorId);
        }
    }
}

export { AnchorNavigation };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$anchorNavigation = $context.querySelectorAll('[data-anchor-navigation="root"]');

    if ($$anchorNavigation.length > 0) {
        $$anchorNavigation.forEach(($anchorNavigation) => {
            const anchorNavigation = new AnchorNavigation($anchorNavigation, { // eslint-disable-line
                eventScroller: window.eventScroller
            });
        });
    }
});
